import { defineStore } from 'pinia';
import { SetProp } from '../types/auth.type';
import { TypeDataProvider } from '../types/dataProvider.type';

export const useDataProviderStore = defineStore('dataProvider', {
  state: (): TypeDataProvider => ({
    operations: [],
    certificates: [],
    companiesGPS: [],
    users: [],
    agents: [],
    templatesUI: [],
    countries: [],
    typesContainers: [],
    roles: [],
    languages: [],
    assets: [],
    subAssets: [],
    products: [],
    securityMeasures: [],
    taxes: [],
    companies: [],
    whiteListOfac: [],
    configCertificates: [],
  }),
  actions: {
    setProp(payload: SetProp) {
      return new Promise((resolve) => {
        if (payload.index !== undefined) {
          if (payload.prop !== undefined) {
            // @ts-ignore
            this[payload.key as keyof TypeDataProvider][payload.index][payload.prop] = payload.value;
            // @ts-ignore
            resolve(this[payload.key as keyof TypeDataProvider][payload.index][payload.prop]);
          } else {
            // @ts-ignore
            this[payload.key as keyof TypeDataProvider][payload.index] = payload.value;
            // @ts-ignore
            resolve(this[payload.key as keyof TypeDataProvider][payload.index]);
          }
        } else {
          // @ts-ignore
          this[payload.key as keyof TypeDataProvider] = payload.value;
          resolve(this[payload.key as keyof TypeDataProvider]);
        }
      });
    },
    deleteItem(payload: SetProp) {
      if (payload?.key && payload?.value) {
        const indexItem = this[payload.key as keyof TypeDataProvider].findIndex(
          elem => elem.id === payload.value
        )
        this[payload.key as keyof TypeDataProvider].splice(indexItem, 1)
      }
    },
    pushItem(payload: { key: keyof TypeDataProvider; value: any }): Promise<any> {
      return new Promise((resolve, reject) => {
        const { key, value } = payload;
        const target = this[key];

        if (!target) {
          reject(new Error(`Key "${key}" does not exist in store`));
          return;
        }

        if (!Array.isArray(target)) {
          reject(new Error(`Key "${key}" is not an array and cannot push items`));
          return;
        }

        target.push(value);
        resolve(value);
      });
    },
  },
  getters: {
    getState: (state) => (key: string): any => {
      return state[key as keyof object];
    },
  },
});

export default useDataProviderStore;
